<template>
  <div id="loginVue" v-cloak>
    <user-template>
      <template #title>
        <el-col :span="10">{{ form.weChatLogin }}</el-col>
        <el-col :span="14">{{ form.userNameLogin }}</el-col>
      </template>
      <template #content>
        <el-row class="loginModel">
          <el-col :span="10" class="weChatLogin ">
            <a href="javascript: void(0);" @click="showQrCode"
               style="position:relative; display:inline-block; width: 180px;height: 180px; margin: 0 auto">
              <div id="qrCode" fit="fill"></div>
              <div class="qrCodeMask" v-show="qrCodeMaskVisible">
                <i class="el-icon-refresh"></i>
                <span>二维码已过期,点击刷新</span>
              </div>
            </a>
            <div style="padding: 12px 0">请用微信APP扫码</div>
          </el-col>
          <el-col :span="14" class="userNameLogin">
            <el-form ref="form" :model="form" label-width="80px">
              <el-form-item label="账户">
                <el-input v-model="form.user" @change="phoneNumberChange"></el-input>
              </el-form-item>
              <el-form-item label="密码" v-if="loginType===1">
                <el-input v-model="form.password" show-password></el-input>
              </el-form-item>
              <el-form-item label="验证码" v-else class="captcha">
                <el-input v-model="form.smsCode" show-password></el-input>
                <el-button type="primary" style="float: right" @click="get_code" v-if="!getCodeDisabled">
                  {{form.getCaptcha}}
                </el-button>
                <el-button type="primary" style="float: right" disabled v-else>{{clock}}</el-button>
              </el-form-item>
              <el-form-item label="图片验证" v-show="needImgVerifyCode_password">
                <el-input v-model="imgVerifyCode" class="captcha"></el-input>
                <img id="imgVerifyCode" alt="点击更换" title="点击更换" @click="changeImg"
                     :src="$axios.defaults.baseURL + '/message/getImgVerifyCode'">
              </el-form-item>
              <el-form-item label="" prop="type">
                <div style="display: flex;">
                  <el-checkbox style="" label="记住密码" name="type" v-model="form.type"></el-checkbox>
                  <div @click="loginType=1-loginType" style="cursor: pointer;margin-left: 15px">
                    <span class="el-link--inner">
                    {{ loginType===1 ? "验证码登录" : "密码登录" }}
                    </span>
                  </div>
                  <div style="margin-left: auto">
                    <router-link class="el-link el-link--default is-underline" :to=form.forgetPasswordUrl
                                 style="line-height: 40px;">
                  <span class="el-link--inner">
                    {{ form.forgetPassword }}
                  </span>
                    </router-link>
                  </div>
                </div>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="login">{{ form.login }}</el-button>
              </el-form-item>
              <el-form-item label="" prop="type">
                 <router-link class="el-link el-link--default is-underline" :to="{path: form.registerUrl, query: $route.query}" style="float: right; line-height: 40px;">
                <span class="el-link--inner">
                    {{ form.register }}
                  </span>
                </router-link>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </template>
    </user-template>
  </div>

</template>

<script>
let self;
import Vue from "vue";
import UserTemplate from "./UserTemplate";
import getUserInfo from "@/assets/js/user/getUserInfo";
import API from "../../../config/api";
import DOMAIN_PREFIX from "../../../config/domainPrefix";

export default {
  components: {UserTemplate},
  data() {
    return {
      form: {
        user: '',
        password: '',
        smsCode: "",
        type: false,
        login: '登录',
        weChatLogin: "微信登录",
        userNameLogin: "账户登录",
        forgetPasswordUrl: `/pages/login/ForgetPassword`,
        forgetPassword: "忘记密码",
        registerUrl: `/pages/login/UserRegister`,
        register: "没账户？现在去注册>>",
        getCaptcha: '获取验证码',
      },
      style: {
        refreshHeight: '100%',
      },
      imgVerifyCode: '',
      needImgVerifyCode_password: false,
      /*页面配置参数*/
      redirectUrl: undefined,  // 登录拦截页面
      logoUrl: require("@/assets/login/yunKongLogo.png"),
      codeUrl: require("@/assets/login/ybg-code.jpg"),
      logoItem: require("@/assets/login/yunKongLogo.png"),
      codeItem: require("@/assets/login/ybg-code.jpg"),
      configSet: true,
      qrCodeVisible: false,
      qrCodeMaskVisible: false,
      wxInt: undefined,
      queryTime: 0,
      scanId: undefined,
      scanPassword: undefined,

      loginType: 0, //0-验证码登录 1-密码登录
      getCodeDisabled: false,
      clock: '',
      itemCompanyList: [],         //与用户关联的公司列表
      canReadId: undefined,        //用户被分配到的主页面id
    }
  },
  methods: {
    login() {

      var self = this;
      if (!/^1[9|3|4|5|7|8][0-9]{9}$/.test(self.form.user)) {
        self.$message({type: 'warning', message: '账号(手机号码)格式错误'});
        return;
      }
      if (self.needImgVerifyCode_password && self.imgVerifyCode == '') {
        self.$message({type: 'warning', message: '图片验证码不可以为空'});
        return;
      }
      if(this.loginType===1) {
        if (self.form.password == '') {
          self.$message({type: 'warning', message: '密码不可以为空'});
          return;
        }
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("userid");
        let data = {
          account: self.form.user,
          password: self.form.password,
          imgVerifyCode: self.imgVerifyCode
        }
        this.$axiosRequest({
          url: API.userLogin,
          method: 'GET',
          data: data,
          success: async function (res) {
            self.imgVerifyCode = ''// 清空输入框
            console.log(res)
            if (res.data.status == 0) {
              // 将信息缓存到本地
              if (self.form.type === true) {
                window.localStorage.setItem("account", self.form.user);
                window.localStorage.setItem("password", self.form.password);
                window.localStorage.setItem("rememberUser", "yes");
              } else {
                window.localStorage.removeItem("account");
                window.localStorage.removeItem("password");
                window.localStorage.removeItem("rememberUser");
              }
              window.localStorage.setItem('userid', res.data.userid);
              window.localStorage.setItem('token', res.data.token);
              await self.saveUser()
              self.$message({type: 'success', message: '登录成功'});
              if (self.wxInt)
                window.clearInterval(self.wxInt);//删除定时器
              // self.$router.replace({path: self.redirectUrl})
              setTimeout(() => {
                self.afterLogin()
              }, 1000)

            } else if (res.data.status == 1) {
              self.$message({type: 'warning', message: '账号密码错误'});
              self.testIfNeedImgVerifyCode_password() // 每次密码错误后，测试下一次是否需要图片验证码
            } else if (res.data.status == 2) {
              self.$message({type: 'warning', message: '用户不存在'});
              this.showAlert('error', '用户不存在');
            } else if (res.data.status == 3) {
              self.$message({type: 'warning', message: '图片验证码输入不正确，请重新输入'});
              self.testIfNeedImgVerifyCode_password();// 每次密码错误后，测试下一次是否需要图片验证码
            } else if (res.data.status == 4) {
              self.$message({type: 'warning', message: '图片验证码不能为空'});
              self.needImgVerifyCode_password = true
            } else {
              self.$message({type: 'warning', message: '登录失败，请稍后再试'});
            }
          }
        });
      }else{
        let data = {
          account: self.form.user,
          password: self.form.password,
          imgVerifyCode: self.imgVerifyCode,
          smsVerifyCode: self.form.smsCode
        }
        this.$axiosRequest({
          url: API.userRegisterOrLogin,
          method: 'GET',
          data: data,
          success: async function (res) {
            self.imgVerifyCode = ''// 清空输入框
            console.log(res)
            if (res.data.status == 0) {
              // 将信息缓存到本地
              if (self.form.type === true) {
                window.localStorage.setItem("account", self.form.user);
                window.localStorage.setItem("password", self.form.password);
                window.localStorage.setItem("rememberUser", "yes");
              } else {
                window.localStorage.removeItem("account");
                window.localStorage.removeItem("password");
                window.localStorage.removeItem("rememberUser");
              }
              window.localStorage.setItem('userid', res.data.userid);
              window.localStorage.setItem('token', res.data.token);
              await self.saveUser()
              self.$message({type: 'success', message: '登录成功'});
              if (self.wxInt)
                window.clearInterval(self.wxInt);//删除定时器
              // self.$router.replace({path: self.redirectUrl})
              setTimeout(() => {
                self.afterLogin()
              }, 1000)

            } else if (res.data.status == 1) {
              self.$message({type: 'warning', message: '验证码错误'});
              self.testIfNeedImgVerifyCode_password() // 每次密码错误后，测试下一次是否需要图片验证码
            } else if (res.data.status == 2) {
              self.$message({type: 'warning', message: '用户不存在'});
              this.showAlert('error', '用户不存在');
            } else if (res.data.status == 3) {
              self.$message({type: 'warning', message: '图片验证码输入不正确，请重新输入'});
              self.testIfNeedImgVerifyCode_password();// 每次密码错误后，测试下一次是否需要图片验证码
            } else if (res.data.status == 4) {
              self.$message({type: 'warning', message: '图片验证码不能为空'});
              self.needImgVerifyCode_password = true
            } else {
              self.$message({type: 'warning', message: '登录失败，请稍后再试'});
            }
          }
        });
      }



    },
    get_code() {
      // 获取验证码
      let self = this;
      if (self.form.user === '') {
        self.$message({type: 'warning', message: '手机号不能为空'});
      } else if (!(/^1[3456789]\d{9}$/.test(self.form.user))) {
        self.$message({type: 'warning', message: '手机号格式不正确'});
      } else if (self.needImgVerifyCode && self.imgVerifyCode === '') {
        self.$message({type: 'warning', message: '图片验证码不应该为空'});
      } else {
        self.getCodeDisabled = true;
        let header = {
          "Content-Type": "application/x-www-form-urlencoded"
        }
        let data={
          type: 1,
          phoneNumber: self.form.user,
          imgVerifyCode: self.imgVerifyCode
        }

        this.$axiosRequest({
          url: API.sendCode,
          method: 'GET',
          data: data,
          header: header,
          success: res => {
            console.log(res)
            if (res.data == 0) {
              self.$message({type: 'success', message: '验证码发送成功'});
              self.testIfNeedImgVerifyCode();// 每次验证码发送成功后，测试下一次是否需要图片验证码
            } else if (res.data == 1) {
              self.$message({type: 'warning', message: '图片验证码输入不正确，请重新输入'});
            } else if (res.data == 2) {
              self.$message({type: 'warning', message: '请先输入图片验证码后才可获取短信验证码'});
            } else {
              self.$message({type: 'warning', message: '获取验证码失败，请稍后再试'});
            }
          }
        });
        let time = 59;
        self.clock = time + "s后重新发送";
        let cleartime = setInterval(() => {
          if (time <= 0) {
            self.clock = "重新获取";
            self.getCodeDisabled = false;
            clearInterval(cleartime);
            return false;
          }
          time -= 1;
          self.clock = time + "s后重新发送";
        }, 1000);
      }
    },

    saveUser: async function () {
      await getUserInfo()
    },
    onSubmit() {

    },
    //登录结束后，执行跳转
    afterLogin(){
      self.$axiosRequest({
        url: API.getUserCompanyList,
        method: 'POST',
        data: {},
        success: res1 => {
          self.itemCompanyList = res1.data["companyList"];
          if (self.itemCompanyList.length == 0) {
            this.$router.push({path: '/pages/userCenter/UserCenter'})
          } else if (self.itemCompanyList.length == 1) {
            if (self.itemCompanyList[0].role_type == 0) {
              window.localStorage.setItem("companyId",self.itemCompanyList[0].companyId);
              window.localStorage.setItem("companyRoleType",self.itemCompanyList[0].role_type);
              window.localStorage.setItem("companyName",self.itemCompanyList[0].companyName);
              self.$router.push({path: '/pages/MainOperatePage', query: {companyId: self.itemCompanyList[0].companyId}})     //后面改成MainOperatePage
            } else {
              window.localStorage.setItem("companyId",self.itemCompanyList[0].companyId);
              window.localStorage.setItem("companyRoleType",self.itemCompanyList[0].role_type);
              window.localStorage.setItem("companyName",self.itemCompanyList[0].companyName);
              let data2 = {
                companyId: self.itemCompanyList[0].companyId,
                productUserId: window.localStorage.getItem('userid')   //登陆者自身
              }

              self.$axiosRequest({
                url: API.getProductUserList,
                method: 'POST',
                data: data2,
                success: res2 => {
                  let userCanRead = res2.data["productUserList"];
                  if (userCanRead.length != 0)
                    self.canReadId = userCanRead[0].productId;
                  if (userCanRead.length == 0)
                    self.canReadId = null;
                  console.log('uuuuuuuu', userCanRead)
                  console.log('uuuuuuuu', this.canReadId)
                  if (this.canReadId != null) {
                    self.$router.push({
                      path: '/pages/redirect/create',
                      query: {
                        companyId: self.itemCompanyList[0].companyId,
                        editType: "3",
                        productId: self.canReadId
                      }
                    })
                  }
                  if (this.canReadId == null) {
                    self.$message({type: 'success', message: '暂无分配的主页面'});
                    self.$router.push({path: '/pages/userCenter/UserCenter'})
                  }

                }
              });
            }

          } else {
            self.$router.push({path: '/pages/login/LoginCompanySelect'})
          }
        }
      });
    },
    phoneNumberChange: function () {
      if (!/^1[3|4|5|7|8][0-9]{9}$/.test(this.form.user)) {
        this.needImgVerifyCode_password = false;
        return
      } else {
        if (!this.needImgVerifyCode_password)
          this.testIfNeedImgVerifyCode_password()
      }
    },
    changeImg() {
      setTimeout(() => {
        let imgVerifyCode = document.getElementById("imgVerifyCode");
        imgVerifyCode.src = DOMAIN_PREFIX + "/message/getImgVerifyCode?time=" + Math.random(1000) + "&phoneNumber=" + this.form.user;
      }, 500)
    },
    //测试是否需要图片验证码
    testIfNeedImgVerifyCode_password() {
      let self = this;
      if (!/^1[3|4|5|7|8][0-9]{9}$/.test(self.form.user)) {
        return
      }
      if (!self.needImgVerifyCode_password) {// 如果needImgVerifyCode_password已经为true了，就不要再调用接口判断了，直接更换验证码图片
        let header = {
          "Content-Type": "application/x-www-form-urlencoded"
        }

        let data = {}
        this.$axiosRequest({
          url: API.testIfNeedImgVerifyCodePassword,
          method: 'POST',
          data: data,
          header: header,
          success: res => {
            console.log(res)
            if(res.data == 0){
              self.needImgVerifyCode_password = true;
              self.changeImg();
            }
          }
        });
      } else {
        self.changeImg();
      }

    },
    showQrCode: async function () {
      var self = this;
      window.localStorage.removeItem("token");
      window.localStorage.removeItem("userid");
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }

      this.$axiosRequest({
        url: API.addScanLoginRecord,
        method: 'GET',
        data: {},
        header: header,
        success: res => {
          console.log(res)
          if (res.data.scanId == -1) {
            self.$message.error('生成二维码失败，请刷新。')
          } else {
            self.qrCodeVisible = true;
            document.getElementById("qrCode").innerHTML = "";
            // eslint-disable-next-line no-undef
            new QRCode(document.getElementById("qrCode"), {
              text: DOMAIN_PREFIX.WX_LOGIN_PREFIX +
                  'pages/login/AfterScan?scanId=' + res.data.scanId + '&state=0',
              height: '180',
              width: '180',
              colorDark: "#2a2929",
              colorLight: "#ffffff",
            });
            self.scanId = res.data.scanId;
            self.scanPassword = res.data.password;
            if (self.wxInt)
              window.clearTimeout(self.wxInt);//生成定时器之前删除上一个定时器
            this.queryTime = 0
            this.qrCodeMaskVisible = false;
            self.wxInt = setTimeout(async function () {
              self.wXStatus()
            }, 2000);
          }

        }
      });

    },
    wXStatus: async function () {
      var self = this;
      this.queryTime++;
      if (this.queryTime > 60) {
        this.qrCodeMaskVisible = true;
        return
      }
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        scanId: this.scanId,
        password: this.scanPassword
      }
      this.$axiosRequest({
        url: API.getScanLoginState,
        method: 'POST',
        data: data,
        header: header,
        success: async function (res) {
          console.log(res.data.status)

          if (res.data.status == -1) {
            self.wxInt = setTimeout(async function () {
              self.wXStatus()
            }, 2000);
          } else if (res.data.status == 0) {
            self.wxInt = setTimeout(async function () {
              self.wXStatus()
            }, 2000);
          } else if (res.data.status == 1) {
            window.localStorage.setItem('userid', res.data.userid);
            window.localStorage.setItem('token', res.data.token);
            Vue.prototype.$loginStatus = true;

            self.saveUser()
            setTimeout(() => {
              self.afterLogin()
            }, 1000)
          }
        }
      });

    },
  },
  mounted() {
    self = this;
    this.logoUrl = this.logoItem;
    this.showQrCode()
    if (this.configId == 2) this.configSet = true;
    else this.configSet = false;
    this.$forceUpdate();
    var account = window.localStorage.getItem("account")
    var password = window.localStorage.getItem("password")
    var rememberUser = window.localStorage.getItem("rememberUser")
    if (rememberUser == 'yes')
      this.form.type = true
    if (account)
      this.form.user = account
    if (password)
      this.form.password = password
    this.testIfNeedImgVerifyCode_password()
    this.redirectUrl = this.$route.query.redirectUrl ? decodeURIComponent(this.$route.query.redirectUrl) : '/homepage'
    require('@/assets/js/canvas/script.js')
  },
  beforeDestroy() {
    if (this.wxInt) {
      clearTimeout(this.wxInt)
    }
  }
}
</script>

<style lang="less">

#loginVue {
  .loginDiv .weChatLogin {
    text-align: center;
  }

  .loginDiv .weChatLogin img {
    height: 180px;
    width: 180px;
  }

  .loginDiv .weChatLogin img {
    //padding: 10px;
    //border: solid 1px #d9eedc;
  }

  .loginModel {
    background-color: #c2e2ff80;
    opacity: 0.8;
  }

  .loginModel form > div {
    max-width: 90%;
  }

  .loginModel label {
    color: #000000 !important;
  }

  .loginTitle {
    background-color: #3a8ee6;
    padding: 15px 0px;
    margin-bottom: 20px;
    font-size: 18px;
    font-weight: bold;
    max-width: 100% !important;
    letter-spacing: 12px;
    text-align: center;
  }

  .loginModel form a {
    line-height: 20px;
  }

  .loginModel form button {
    width: 100%;
  }

  #qrCode {
    z-index: -999;
    position: absolute;
    margin: 0 auto;
  }

  .qrCodeMask {
    z-index: 999;
    display: inline-block;
    height: 180px;
    width: 180px;
    position: absolute;
    left: 0px;
    background-color: rgba(0, 0, 0, 0.8);
    color: white;
    font-size: 72px;
    //line-height: 150px;
    text-align: center;

    span {
      display: block;
      position: relative;
      font-size: 14px;
      top: 25px;
    }

    i {
      display: block;
      position: relative;
      top: 20px;
    }
  }

  #cvs {
    position: absolute;
  }

  /*图片验证码*/

  #imgVerifyCode {
    position: absolute;
    right: 10px;
    margin: 2px 0;
    height: 36px;
  }

  .captcha {
    height: 40px;
  }

  .captcha > div > div {
    width: 50%;
  }

  .captcha input {
    width: 100% !important;
    border: none;
    border-bottom: solid 1px white;
    border-radius: 0px;
    float: left;
  }

  .captcha button {
    width: 50% !important;
    padding: 12px 14px;
    float: right;
    background-color: #388cd7;
    color: white;
  }

}


</style>
